<template>
  <div id="app" class="page vue-dpn">
    <div class="nav-wrap">
      <van-nav-bar title="进项发票" @click-left="goBack" left-arrow>
        <template #right>
          <van-icon name="plus" @click="goToNew" />
        </template>
      </van-nav-bar>
    </div>

    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" class="page-body">
      <div class="search-wrap">
        <van-search
          v-model="keyword"
          placeholder="搜索上传人/备注"
          show-action
          shape="round"
          @search="onSearch"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>

      <div class="list-wrap">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="invoice-card" v-for="item in list" :key="item.id">
            <div class="card-header">
              <div class="user-block">
                <div class="avatar">{{ avatarText(item.staff_name) }}</div>
                <div class="user-meta">
                  <div class="user-name">{{ item.staff_name || '未知' }}</div>
                  <div class="upload-time">{{ formatDisplayDate(item.created_at) }}</div>
                </div>
              </div>
              <div class="file-count">{{ item.pdf_count || 0 }} 个附件</div>
            </div>

            <div v-if="item.remark" class="remark">{{ item.remark }}</div>

            <div class="file-list" v-if="item.pdf_list && item.pdf_list.length">
              <a
                v-for="(url, idx) in item.pdf_list"
                :key="idx"
                class="file-chip"
                :href="absoluteUrl(url)"
                target="_blank"
                @click.stop
              >
                <span class="file-icon" :class="fileTypeFromUrl(url)">{{ fileTypeLabel(url) }}</span>
                <span class="file-name">{{ truncateFileName(fileNameFromUrl(url)) }}</span>
              </a>
            </div>

            <div v-if="item.can_edit || item.can_delete" class="card-actions">
              <button v-if="item.can_edit" class="action-btn action-edit" @click.stop="goEdit(item)">
                <van-icon name="edit" />
                编辑
              </button>
              <button v-if="item.can_delete" class="action-btn action-delete" @click.stop="doDelete(item)">
                <van-icon name="delete" />
                删除
              </button>
            </div>
          </div>
        </van-list>

        <div v-if="!loading && finished && list.length === 0" class="empty-state">
          <van-icon name="description" class="empty-icon" />
          <div class="empty-text">暂无进项发票</div>
          <van-button type="primary" size="small" round @click="goToNew">去上传</van-button>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import common from '@/assets/js/common'

export default {
  name: 'InputInvoice',
  data () {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      pageNo: 1,
      pageSize: 12,
      keyword: ''
    }
  },
  methods: {
    goBack () {
      this.$router.push({ path: '/' })
    },
    goToNew () {
      this.$router.push({ path: '/new_input_invoice' })
    },
    avatarText (name) {
      const text = (name || '?').trim()
      return text ? text.charAt(0) : '?'
    },
    formatDisplayDate (value) {
      if (!value) return '-'
      const text = String(value)
      if (text.length >= 16) {
        return text.slice(5, 16).replace('T', ' ')
      }
      return text
    },
    absoluteUrl (url) {
      if (!url) return '#'
      if (url.indexOf('http') === 0) return url
      return common.dynamicHost() + url
    },
    fileNameFromUrl (url) {
      if (!url) return '文件'
      const parts = url.split('/')
      return parts[parts.length - 1] || '文件'
    },
    fileTypeFromUrl (url) {
      return /\.pdf$/i.test(url || '') ? 'pdf' : 'docx'
    },
    fileTypeLabel (url) {
      return this.fileTypeFromUrl(url).toUpperCase()
    },
    truncateFileName (name, maxLen = 18) {
      if (!name || name.length <= maxLen) return name
      const extIndex = name.lastIndexOf('.')
      if (extIndex > 0) {
        const ext = name.slice(extIndex)
        const baseMax = maxLen - ext.length - 1
        if (baseMax > 4) {
          return name.slice(0, baseMax) + '…' + ext
        }
      }
      return name.slice(0, maxLen - 1) + '…'
    },
    onSearch () {
      this.pageNo = 1
      this.list = []
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    onRefresh () {
      this.isLoading = false
      this.pageNo = 1
      this.list = []
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    onLoad () {
      common.cusHttp(this, '/admin_input_invoice.php?action=input_invoice_list', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        keyword: this.keyword
      }, 'get').then((res) => {
        res = JSON.parse(res.data)
        if (res.errcode === 200) {
          const data = res.result.data || []
          if (data.length === 0) {
            this.finished = true
            this.loading = false
            return
          }
          for (let i = 0; i < data.length; i++) {
            const row = data[i]
            if (!this.list.find(x => x.id === row.id)) {
              this.list.push(row)
            }
          }
          this.pageNo = this.pageNo + 1
        }
        this.loading = false
      })
    },
    goEdit (item) {
      this.$router.push({ path: '/new_input_invoice', query: { id: item.id } })
    },
    doDelete (item) {
      this.$dialog.confirm({
        title: '确认删除',
        message: '删除后不可恢复，确定删除吗？'
      }).then(() => {
        common.cusHttp(this, '/admin_input_invoice.php?action=delete_input_invoice', { id: item.id }, 'post').then((res) => {
          res = JSON.parse(res.data)
          if (res.errcode === 0) {
            common.mAlert(this, '删除成功')
            this.onSearch()
          } else {
            common.mAlert(this, res.errmsg || '删除失败')
          }
        })
      }).catch(() => {})
    }
  },
  mounted () {
    if (!common.getAuth()) {
      this.$router.push({ path: '/auth' })
      return
    }
    common.removeDpnClass()
    this.loading = true
    this.onLoad()
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #f5f6f8;
  text-align: left;
}

.nav-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: #fff;
}

.page-body {
  padding-top: 46px;
}

.search-wrap {
  padding: 8px 12px 0;
  background: #f5f6f8;
}

.list-wrap {
  padding: 8px 12px 32px;
}

.invoice-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px 14px 10px;
  margin-bottom: 12px;
  box-shadow: 0 2px 10px rgba(17, 24, 39, 0.06);
}

.card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.user-block {
  display: flex;
  align-items: center;
  min-width: 0;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #34c38f 0%, #2f9e79 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-meta {
  margin-left: 10px;
  min-width: 0;
}

.user-name {
  font-size: 16px;
  line-height: 22px;
  color: #1f2937;
  font-weight: 600;
}

.upload-time {
  margin-top: 2px;
  font-size: 12px;
  line-height: 18px;
  color: #9ca3af;
}

.file-count {
  flex-shrink: 0;
  font-size: 12px;
  line-height: 20px;
  color: #6b7280;
  background: #f3f4f6;
  border-radius: 10px;
  padding: 2px 8px;
}

.remark {
  margin-top: 10px;
  font-size: 13px;
  line-height: 20px;
  color: #6b7280;
  background: #f9fafb;
  border-radius: 8px;
  padding: 8px 10px;
  word-break: break-all;
}

.file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.file-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  text-decoration: none;
}

.file-icon {
  flex-shrink: 0;
  min-width: 34px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
}

.file-icon.pdf {
  background: #ef6b5f;
}

.file-icon.docx {
  background: #4b8df8;
}

.file-name {
  margin-left: 8px;
  font-size: 13px;
  line-height: 18px;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #f0f2f5;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  font-size: 13px;
  line-height: 20px;
  padding: 4px 8px;
}

.action-edit {
  color: #2563eb;
}

.action-delete {
  color: #ef4444;
}

.empty-state {
  padding: 48px 16px 24px;
  text-align: center;
}

.empty-icon {
  font-size: 42px;
  color: #d1d5db;
}

.empty-text {
  margin: 12px 0 16px;
  font-size: 14px;
  color: #9ca3af;
}
</style>
